<template>
  <ul class="grid gap-10 gap-y-16 text-center md:grid-cols-3 md:text-left">
    <li v-for="column in columns" :key="column.illustration" class="group flex">
      <component
        :is="column.to ? NuxtLink : 'div'"
        class="relative"
        :to="column.to"
      >
        <div
          v-if="column.to"
          class="absolute -inset-4 scale-95 rounded-lg bg-current opacity-0 transition group-hover:scale-100 group-hover:opacity-5"
        />
        <figure class="relative">
          <app-image
            alt=""
            class="aspect-[4/3] rounded-lg object-cover"
            :src="column.illustration"
            :width="600"
          />
          <figcaption class="mt-8">
            <h3 class="mb-3 text-2xl font-extrabold">
              {{ column.title }}
            </h3>
            <p>{{ column.subtitle }}</p>
          </figcaption>
        </figure>
      </component>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { PageColumnCardDefinition } from "~/shared/page/page.model";

defineProps<{
  columns: PageColumnCardDefinition[];
}>();

const NuxtLink = resolveComponent("nuxt-link");
</script>
